import {
  Container,
  Typography,
  Grid,
  Stack,
  Button,
  Drawer,
  Box,
  Tab,
  Card,
  Badge,
  Breadcrumbs,
  Link,
} from '@mui/material';
import { useTheme } from '@mui/material/styles';

// components
import Page from '../components/Page';
import DashboardBreadcrumbLink from 'src/components/DashboardBreadcrumbLink';
import { useEffect, useState } from 'react';
import { AddEditForm } from 'src/sections/servers';
import { getServers } from 'src/api/servers';

import {
  TabContext,
  TabList,
  TabPanel
} from '@mui/lab';
import ServerList from 'src/sections/servers/ServerList';


// ----------------------------------------------------------------------







const anchor = 'right'

const SERVER_INIT_VALUES = {
  serverId: null,
  serverName: "",
  serverType: "",
  isPrivateIp: 0,
  publicIp: "",
  localIp: "",
  aiPort: 9023,
  dns: "",
  protocol: "http",
  instaneorProcessor: "",
  cameraCapacity: ""

}


export default function Servers() {
  const theme = useTheme();
  const tabListSx = {
    borderBottom: `1px solid ${theme.palette.divider}`,
    backgroundColor: theme.palette.background.neutral,
    '& .MuiTab-root': { color: theme.palette.text.secondary },
    '& .MuiTab-root.Mui-selected': { color: theme.palette.text.primary },
    '& .MuiTabs-indicator': { backgroundColor: theme.palette.primary.main },
  };


  const [state, setState] = useState({
    top: false,
    left: false,
    bottom: false,
    right: false,
  });


  const [reloadServer, setReloadServer] = useState(false)
  const [value, setValue] = useState('all');
  const [allServerTypes, setServerTypes] = useState({
    all: {
      key: "all",
      name: "All",
      data: []
    },
    localVirtualMachine: {
      key: "localVirtualMachine",
      name: "Local Virtual Machine",
      data: []
    },
    thirdPartyServer: {
      key: "thirdPartyServer",
      name: "Third Party Server",
      data: []
    },
    clientDevices: {
      key: "clientDevices",
      name: "Client Devices",
      data: []
    },
    iotDevices: {
      key: "iotDevices",
      name: "IOT Devices",
      data: []
    },
    testServer: {
      key: "testServer",
      name: "Test Server",
      data: []
    }
  })

  const [editServerDetails, setEditServerData] = useState({ ...SERVER_INIT_VALUES })
  const [isServerLoading, setIsServerLoading] = useState(false)

  const handleChange = (_, newValue) => {
    setValue(newValue);
  };



  const loadServersList = () => {
    setIsServerLoading(true)
    setReloadServer(!reloadServer)
  }

  useEffect(() => {
    getServers((response) => {
      setIsServerLoading(false)
      if (response.status === 200) {
        if (response.data && response.data !== undefined && response.data !== null) {
          setServerTypes((_) => {
            const serverData = {
              all: {
                key: "all",
                name: "All",
                data: []
              },
              localVirtualMachine: {
                key: "localVirtualMachine",
                name: "Local Virtual Machine",
                data: []
              },
              thirdPartyServer: {
                key: "thirdPartyServer",
                name: "Third Party Server",
                data: []
              },
              clientDevices: {
                key: "clientDevices",
                name: "Client Devices",
                data: []
              },
              iotDevices: {
                key: "iotDevices",
                name: "IOT Devices",
                data: []
              },
              testServer: {
                key: "testServer",
                name: "Test Server",
                data: []
              }
            }
            serverData.all.data = response.data
            serverData.all.count = response.data.length
            const res = response.data.forEach((row) => {
              if (Object.keys(serverData).includes(row.ServerType)) {
                serverData[row.ServerType].data.push(row)
              }
            })
            // console.log("serverData", serverData)
            return { ...serverData }
          })
        }
        // setData(response.data);
      }
    })
  }, [reloadServer])


  const toggleDrawer = (anchor, open) => (event) => {
    // console.log('toggleDrawer',event);
    if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
      return;
    }
    setState({ ...state, [anchor]: open });
    setEditServerData({ ...SERVER_INIT_VALUES })
  };


  const updateServerDetails = (details) => {
    // console.log("Details of server",details);
    setEditServerData({
      ...{
        serverId: details.ServerId,
        serverName: details.ServerName || SERVER_INIT_VALUES.serverName,
        serverType: details.ServerType || SERVER_INIT_VALUES.serverType,
        isPrivateIp: details.IsPrivateIp || SERVER_INIT_VALUES.isPrivateIp,
        publicIp: details.PublicIp || SERVER_INIT_VALUES.publicIp,
        localIp: details.ServerIp || SERVER_INIT_VALUES.localIp,
        aiPort: details.AiPort || SERVER_INIT_VALUES.aiPort,
        dns: details.DNS || SERVER_INIT_VALUES.dns,
        protocol: details.Protocol || SERVER_INIT_VALUES.protocol,
        instaneorProcessor: details.Processor || SERVER_INIT_VALUES.Processor,
        cameraCapacity: details.CameraCapacity || SERVER_INIT_VALUES.CameraCapacity

      }
    })
    setState((lastStateData) => ({ ...lastStateData, right: true }));
  }

  return (
    <Page title="Servers">
      <Container maxWidth="xxl"  sx={{ p: 0 }}>


        <Drawer
          anchor={anchor}
          open={state[anchor]}
          onClose={toggleDrawer(anchor, false)}
        >
          <AddEditForm
            onClose={toggleDrawer}
            serverDetails={editServerDetails}
            loadServersList={loadServersList} />
        </Drawer>


        <Box sx={{ mb: 4 }}>
          <Box display="flex" alignItems="center" justifyContent="space-between" mb={1}>
            <Typography variant="h4">Servers</Typography>
            <Button variant="contained" onClick={toggleDrawer(anchor, true)}>Add Server</Button>
          </Box>
          <Breadcrumbs separator="•" aria-label="breadcrumb">
            <DashboardBreadcrumbLink sx={{ fontSize: '0.875rem' }} />
            <Typography color="text.secondary" sx={{ fontSize: '0.875rem' }}>Settings</Typography>
            <Typography color="text.primary" sx={{ fontSize: '0.875rem' }}>Servers</Typography>
          </Breadcrumbs>
        </Box>







        <Card>
          <Box sx={{ width: '100%', typography: 'body1' }}>
            <TabContext value={value}>
              <Box sx={{ borderBottom: 1, borderColor: 'divider', backgroundColor: theme.palette.background.neutral }}>
                <TabList sx={tabListSx} onChange={handleChange} aria-label="lab API tabs example">
                  {Object.keys(allServerTypes).map((key, index) => (
                    <Tab
                      style={{ minHeight: "50px" }}
                      key={index}
                      icon={<Badge style={{ minHeight: "auto", marginLeft: "15px" }} badgeContent={String(allServerTypes[key].data.length)} color="primary" />}
                      iconPosition="end"
                      label={allServerTypes[key].name}
                      value={key}
                       />
                  ))}
                </TabList>
              </Box>
              {Object.keys(allServerTypes).map((key, index) => (
                <TabPanel key={index} sx={{ p: 0 }} value={key}>
                  <ServerList servers={allServerTypes[key].data} titleKey={key} handleUpdateDetails={updateServerDetails} loadServersList={loadServersList} isServerLoading={isServerLoading} />
                </TabPanel>
              ))}
            </TabContext>
          </Box>
        </Card>








      </Container>
    </Page>
  );
}
